import { lazy } from 'react';
import i18next from 'i18next';

import { HOME_PAGE_KEY, PATHS } from './constants';

const HomePage = lazy(() => import('./HomePage'));

['uk-UA', 'en-US'].forEach((lang) =>
  i18next.addResourceBundle(lang, HOME_PAGE_KEY, require(`./i18n/${lang}`).default)
);

export const HomePageConfigNavigationConfig = {
  id: HOME_PAGE_KEY,
  title: 'Users Help',
  translate: 'USERS_HELP',
  type: 'item',
  icon: 'navigation:home-page',
  url: PATHS.HOME_PAGE,
  auth: ['*'],
};

export const HomePageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: ['*'],
  routes: [
    {
      path: PATHS.HOME_PAGE,
      element: <HomePage />,
    },
  ],
};
